



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ResultLog } from '@/class/room'
import { MASTER_ROLE } from '@/class/const'
import { Twitter } from '@/class/twitter'
import { RoleId } from '@/enum'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import BoxNotchFrame from '@/components/Utils/box/BoxNotchFrame.vue'
import HeadlineBorder from '@/components/Utils/headline/HeadlineBorder.vue'

@Component({
  components: {
    BtnSquare,
    BoxNotchFrame,
    HeadlineBorder
  }
})
export default class TotalResult extends Vue {
  @Prop() playerId!: string;
  @Prop() resultLogs!: ResultLog[];
  twitter = new Twitter();

  get myResultLogs () {
    return this.resultLogs.filter(log => log.playerRoles[this.playerId] != null)
  }

  getRoleName(roleId: RoleId) {
    return MASTER_ROLE[roleId].name
  }

  isWin (resultLog: ResultLog) {
    return resultLog.winnerPlayerIds.some(playerId => playerId === this.playerId)
  }

  tweet (): void {
    let message = '今回の戦績%0d%0a'
    for (const resultLog of this.myResultLogs) {
      const resultMark = this.isWin(resultLog) ? '⭕' : '❌'
      const winnerRoleNames = []
      for (const roleId of resultLog.winnerRoleIds) {
        winnerRoleNames.push(this.getRoleName(roleId))
      }
      const winnerRole = winnerRoleNames.join(' ')
      message += `${this.getRoleName(resultLog.playerRoles[this.playerId])}${resultMark}${winnerRole}勝利%0d%0a`
    }

    this.twitter.tweet(message)
  }
}
